<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title=" Check-In Premis">
      <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white" >
    <template  #title>
      <w-icon class="mr2" >fal fa-times-circle</w-icon>
      Permohonan Ditolak 
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit1(form.id)"
      @success="success"
    >
    <z-input label="Catatan" v-model="form.keterangan" name="Keterangan" :validators="[validators.required]" />
    </w-form>
        
    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        SIMPAN
      </w-button>
    </template>

    <template #button>
        <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
        </w-button>
    </template>
   

    
  </w-dialog>
		  <z-table title="Senarai" :headers="table.headers" :items="table.items" :meta="table.meta">
          
		    <template #header-label="{ header, label, index }">
		      <template v-if="header.key == 'action'">
			    <!--   <w-icon xs>fal fa-pencil</w-icon> -->
          Tindakan
          </template>
		      <template v-else>
		      	{{ label }}
		      </template>
		    </template>
		    <template #item-cell.action="{ item, label, header, index }">
		      <w-flex class="flex justify-center">
            
            <template v-if="item.lkp_status_id == 16 || item.lkp_status_id != 21">
		        <inertia-link :href="$route('pemeriksaan.show',item.id)" > 
              <w-button class="ma1" bg-color="success">
              <w-icon class="mr1">wi-check</w-icon>
              Terima
              </w-button>
            </inertia-link>
              <w-button class="fs-2 pr3 bs" bg-color="error" tile @click="batal(item)">
              <w-icon class="mr1">wi-cross</w-icon>
              Tolak
               </w-button>
            </template>
            <template v-else>
            <inertia-link :href="$route('pemeriksaan.show',item.id)" > 
              <w-button class="ma1" bg-color="primary">
              <w-icon class="mr1">fal fa-eye</w-icon>
              Papar
              </w-button>
            </inertia-link>
          </template>
		      </w-flex>
		    </template>
		  </z-table>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'pemeriksaan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Check In', route: '/pemeriksaan' },
      ],
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          item: {name: '', email: '', mobile: ''}
        },

      
    }
    

  },
  methods: {

   submit1(id){
      this.dialog.show = false
      var param = {
         batal : 1,
         keterangan : this.form.keterangan,
      };
        this.$zcomm.batal(this.resourceurl + '.update', id, param)
        .then(res => {
          this.$inertia.visit(this.$route('pemeriksaan.index'))
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
        })
     },

   add(id){
          this.form = {
              keterangan : null,
              id :id,
             

          }
          this.dialog.show = true
          this.form.saveButton = "Save"
      },

    batal(form){
          this.form = form
          this.dialog.show = true
          this.form.saveButton = "Save"
      }
  
  
  },

  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
